export default function convertId(text) {
  return text
    .replace(/[^\w]/g, '')
    .replace(/\d+/g, '')
    .toLowerCase();
}
